import { inject, Injectable, OnInit } from "@angular/core";
import Keycloak from 'keycloak-js';

@Injectable()
export class PermissionJWTService{

    private readonly keycloak = inject(Keycloak)
    // tokenDecoded: any
    tokenDecoded = this.keycloak.tokenParsed

    getPermission() {
      if (!this.tokenDecoded) {
        return [];
      }

      let clientId = '';

      if (Array.isArray(this.tokenDecoded.aud)) {
        // pega o primeiro client que não é "app-home"
        clientId = this.tokenDecoded.aud.find((aud: string) => aud !== 'app-home' && aud !== 'account') ?? '';
      } else {
        clientId = this.tokenDecoded.aud ?? '';
      }

      return this.tokenDecoded.resource_access?.[clientId]?.roles || [];
    }

      // Helper method to parse JWT token (decodes it)
    private parseJwt(token: string): any {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);

    }
}
